import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import { withTranslation } from 'react-i18next'
import Icon from '../../../Icon'
import './styles.scss'
import {
  getAttributeRequired,
  getComponentDefinition,
  getComponentLabel,
  getComponentType,
  getTrackingFactLabel
} from '../../helper'
import { factsheetValidator } from '../../validator'
import get from 'lodash.get'
import InputTracked from '../../../FormTracked/InputTracked'
import { trackingEvent } from '../../../../../constants'

class AttributeInput extends PureComponent {

  state = {
    valid: true,
    required: false
  }

  componentDidMount () {
    this.updateState()
  }

  componentDidUpdate () {
    this.updateState()
  }

  onValueChange = (e) => {
    if (e.target.value === '') {
      this.props.deleteAttribute(
        this.props.parentBlueprint.id,
        this.props.factInstanceKey,
        this.props.blueprint.id
      )
    } else {
      this.props.putAttribute(
        this.props.parentBlueprint.id,
        this.props.factInstanceKey,
        this.props.blueprint.id,
        {
          attributeDefId: this.props.blueprint.id,
          value: e.target.value
        })
    }
  }

  updateState () {
    const factDefId = this.props.parentBlueprint.id
    const fact = this.props.factsheetBlueprint.factTree.facts[factDefId]

    const attributeDefId = this.props.blueprint.id
    const attribute = this.props.factsheetBlueprint.factTree.attributes[attributeDefId]
    const required = getAttributeRequired(this.props.blueprint, attribute, fact)
    let value = ''
    if (typeof this.props.data !== 'undefined') {
      value = this.props.data.value
    }
    let valid = !(!!required.attribute && value === '')
    if (valid && value !== '') {
      valid = factsheetValidator.validateValue(value, attribute)
    }
    if (valid !== this.state.valid || !!required.attribute !== this.state.required) {
      this.setState(
        {
          valid,
          required: !!required.attribute
        }
      )
      this.props.putValidationStatus(factDefId, this.props.factInstanceKey, attributeDefId, valid)
    }
  }

  renderPreviewValue (attributeValueType, value) {
    switch (attributeValueType) {
      case 'URL':
        return <a target={'_blank'} href={value} rel={'noreferrer'}>{value}</a>
      default:
        return value
    }
  }

  render () {
    const attributeDefId = this.props.blueprint.id
    const attribute = this.props.factsheetBlueprint.factTree.attributes[attributeDefId]
    const attributeType = getComponentType(this.props.blueprint, attribute)
    const type = attributeType === 'INTEGER' || attributeType === 'NUMBER' ? 'number' : 'text'

    let value = ''
    if (typeof this.props.data !== 'undefined') {
      value = this.props.data.value
    }

    let label = getComponentLabel(
      this.props.blueprint,
      attribute
    )

    if (this.props.collapsed) {
      if (value === '') {
        return null
      }
      return <div className={'attribute-input-collapsed'}>{label}: {this.renderPreviewValue(
        get(attribute, 'value.type'), value
      )}</div>
    }

    const definition = getComponentDefinition(
      this.props.blueprint,
      attribute
    )
    const showActions = !!definition

    return (
      <div className={'attribute-input'}>
        <div className={'attribute-input-header'}>
          {
            this.props.showLabel && (
              <label>
                {label} {this.state.required ? '*' : ''}
              </label>
            )
          }
          {
            this.props.showLabel && showActions && (
              <div className={'attribute-input-actions'}>
                {definition && <Icon type={'how'} tooltip={definition}/>}
              </div>
            )
          }
        </div>
        <InputTracked
          eventName={trackingEvent.editValue}
          eventOpts={
            {
              name: getTrackingFactLabel(
                this.props.parentBlueprint, this.props.factsheetBlueprint)
            }
          }
          type={type}
          // lock numbers to positive only
          min={attributeType === 'NUMBER' ? 0 : undefined}
          step={attributeType === 'INTEGER' ? 1 : undefined}
          value={value}
          onChange={this.onValueChange}
          valid={this.state.valid}/>
      </div>
    )
  }
}

AttributeInput.defaultProps = {
  showLabel: true
}

AttributeInput.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  data: PropTypes.object,
  collapsed: PropTypes.bool.isRequired,
  putAttribute: PropTypes.func.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
  putValidationStatus: PropTypes.func.isRequired,
  showLabel: PropTypes.bool
}
export default withTranslation()(AttributeInput)
